<div class="flex flex-col gap-6">
	<div class="flex flex-row items-center justify-between">
		<h2>API keys</h2>
		<div class="flex flex-col items-end gap-1">
			<span data-testid="create-wrapper" [attr.title]="canCreate() ? null : 'Máximo 3 keys activas'">
				<activar-button
					data-testid="create"
					text="Crear API key"
					fill="solid"
					color="primary"
					[disabled]="!canCreate()"
					(click)="requestCreate()" />
			</span>
			@if (!canCreate()) {
				<span class="text-xs text-gray-500">Máximo 3 keys activas</span>
			}
		</div>
	</div>

	<app-api-keys-list
		[rows]="rows()"
		[loading]="loading()"
		[error]="loadError()"
		(create)="requestCreate()"
		(retry)="retry()"
		(delete)="askDelete($event)" />
</div>

@if (pendingDelete(); as target) {
	<app-api-key-delete-modal
		[apiKey]="target"
		[deleting]="deleting()"
		(confirm)="confirmDelete()"
		(dismissed)="cancelDelete()" />
}

@if (showCreate()) {
	<app-api-key-create-modal (closed)="onCreateClosed($event)" (limitReached)="onCreateLimitReached()" />
}
